export default "__VITE_ASSET__CaNS4813__"